define( function() {
	return ( /^margin/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/css/var/rmargin.js
 ** module id = 430
 ** module chunks = 2
 **/